import $ from 'jquery';
import pusher from 'pusher-js';
import {init as activityFeed} from './activity-feed';
import {notifier} from './loader';
import { goToNowOnline, goToTutorials } from './slider-now-online';
import Translator from 'bazinga-translator';

function PusherActivityStreamer(activityChannel, options) {
    var self = this;

    options = options || {};
    this.settings = $.extend({
        maxItems: 3
    }, options);

    this._activityChannel = activityChannel;

    this._activityChannel.bind('activity', function (activity) {
        self._handleActivity.call(self, activity, activity.type);
    });

};

PusherActivityStreamer.prototype._handleActivity = function (activity, eventType) {

    var notificator = $('.js-notificator');
    var notificatorCounter = parseInt(notificator.html());

    notificatorCounter++;

    if (!notificator.hasClass('is-active')) {
        notificator.addClass('is-active');
    }

    notificator.html(notificatorCounter);

    notifier.showCustomNotification('success', Translator.trans('notification_modals.new_action_text', [], 'app'));

    activityFeed();

};


PusherActivityStreamer._buildListItem = function (activity) {
    var li = $('<li class="activity"></li>');
    li.attr('data-activity-id', activity.id);
    var item = $('<div class="stream-item-content"></div>');
    li.append(item);

    var content = $('<div class="content"></div>');
    item.append(content);

    var user = $('<div class="activity-row">' +
        '<span class="user-name">' +
        '<a class="screen-name">' + activity.title + '</a>' +
        //'<span class="full-name">' + activity.actor.displayName + '</span>' +
        '</span>' +
        '</div>');
    content.append(user);

    var message = $('<div class="activity-row">' +
        '<div class="text">' + activity.text + '</div>' +
        '</div>');
    content.append(message);

    return li;
};

function createRow(member) {
    // console.log(member);

var template = '<tr id="online-' + member.id + '">' +
    '<td class="table__cell">' +
    // '<div></div> ' +
    '<div> ' +
    '<a href="' + member.info.url + '/edit" target="_blank">' + member.info.title + '</a> ' +
    // '</div> </td> <td class="table__cell"> <div class="tooltip"> <div class="tooltip__text">userAgent</div></div></td></tr>':
    '</div></td></tr>';

    if (member.info.type === 'estimation') {
        $('#js-now-online').append(template);
        goToNowOnline();
    }
}

function deleteRow(member) {
    // console.log('deleted');
    $('#online-' + member.id).remove();

    setTimeout(function() {
        if ($('#js-now-online').children().length === 0) {
            goToTutorials();
        }
    }, 3000);

}


function setPusher() {

    var body = $('body');
    var pusherKey = body.data('pusher-key');
    var pusherChannel = body.data('pusher-channel');

    var pusher = new Pusher(pusherKey, {
        authEndpoint: '/pusher/auth',
        auth: {
            params: {
                type: 'admin'
            }
        },
    });
    var channel = pusher.subscribe(pusherChannel);

    channel.bind('pusher:subscription_succeeded', function(members) {
        // console.log('Pusher connected');
        members.each(function(member) {
            createRow(member);
        });
    });

    channel.bind('pusher:member_added', function (member) {
        createRow(member);
    });

    channel.bind('pusher:member_removed', function (member) {
        deleteRow(member);
    });

    var streamer = new PusherActivityStreamer(channel);
}

function init() {

    var notificator = $('.js-notificator');
    var notificatorCounter = parseInt(notificator.html());
    var pusherKey = $('body').attr('data-pusher-key');

    if (notificatorCounter !== 0) {
        notificator.addClass('is-active');
    }

    if (typeof pusherKey !== typeof undefined && pusherKey !== false) {

        setPusher();

    }

}

export {init};


// WEBPACK FOOTER //
// ./src/_app/layout/pusher.js